import React from "react";
import { createRoot } from "react-dom/client";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import "./stylesheets/tailwind.css";
import "./stylesheets/index.scss";
import "react-day-picker/style.css";

import "./register-chart-plugins";

import AppRouter from "./AppRouter";

import BugsnagErrorBoundary from "./bugsnag";

import LiveSession from "./livesession";
import "./pendo";
import { isDev } from "./env";

import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./utils/react-query";
import {
  ErrorComponent,
  refreshOnceOnDynamicImportError,
} from "./global_functions/errorBoundaryUtils";

const container = document.getElementById("root");

LiveSession.initialize();

if (container) {
  const root = createRoot(container);
  root.render(
    <BugsnagErrorBoundary
      onError={(e) => {
        refreshOnceOnDynamicImportError(e.originalError);
      }}
      FallbackComponent={ErrorComponent}
    >
      <QueryClientProvider client={queryClient}>
        <AppRouter />
        {isDev && (
          <ReactQueryDevtools
            initialIsOpen={false}
            buttonPosition="bottom-left"
          />
        )}
      </QueryClientProvider>
    </BugsnagErrorBoundary>
  );
}
